/* DON'T EDIT THIS FILE: edit original and run build again */ import { Roles } from "../../framework/permission/schema.ts";
import { PermissionCollection } from "../../framework/permission/types.ts";
import {
  canDeleteSgrReportComments,
  canEditSgrReport,
  canViewSgrReport,
} from "./permissions.ts";

const sgrReportPermissions: PermissionCollection = {
  namespace: "sgrReport",
  permissions: [
    {
      name: canViewSgrReport,
      description: "Puede ver el reporte SGR",
      roles: [
        Roles.sales,
        Roles.salesManager,
        Roles.producer,
        Roles.headOfProducers,
        Roles.investor,
        Roles.guestBank,
        Roles.guestSgr,
        Roles.analyst,
        Roles.matchfinAnalyst,
        Roles.admin,
        Roles.tenantAdmin,
        Roles.backOffice,
        Roles.trader,
        Roles.endClientUser,
        Roles.portfolioManager,
        Roles.complianceOfficer,
      ],
    },
    {
      name: canEditSgrReport,
      description: "Puede crear, eliminar, editar el reporte SGR",
      roles: [Roles.admin, Roles.matchfinAnalyst],
    },
    {
      name: canDeleteSgrReportComments,
      description: "El usuario puede eliminar comentarios en los reportes SGR",
      roles: [Roles.admin, Roles.matchfinAnalyst],
    },
  ],
};

export default sgrReportPermissions;
